import { useSelector } from "react-redux";
import trans from "../../../../utils";
import { isRTL } from "../../../../utils";

export default function ReportTotals({ title, number, type }) {
	function getValue(value) {
		return value !== undefined && value !== null && !isNaN(value)
			? value
			: "***";
	}
	// function knotsToKmPerHour(knots) {
	//   return knots * 1.852;
	// }
	const inf = useSelector((state) => state.users.user);
	function convertMillisecondsToTime(ms) {
		if (!ms) return "----";
		const totalMinutes = Math.floor(ms / 60000);
		const hours = Math.floor(totalMinutes / 60);
		const minutes = totalMinutes % 60;

		if (isRTL) {
			return `${hours}س ${minutes}د`;
		} else {
			return `${hours}h ${minutes}m`;
		}
	}

	// Vehicles - Speed - Distance - Fuel
return (
  <div className="report-sheet-total">
    <div className="text-capitalize mb-2">{title}</div>
    <div className="fw-700 fs-18">
      {type === "speed"
        ? getValue(Math.round(number)) + " " + trans(inf.attributes.speedUnit || "kn")
        : type === "distance"
        ? getValue(Math.round(number)) + " " + trans(inf.attributes.distanceUnit || "km")
        : type === "fuel"
        ? getValue(Math.round(number)) + " " + trans(inf.attributes.volumeUnit || "ltr")
        : type === "vehicles"
        ? getValue(number)
        : type === "time"
        ? convertMillisecondsToTime(getValue(number))
        : type === "timeT"
        ? number
        : number}
    </div>
  </div>
);

}
